import { rem } from "polished";
import styled from "styled-components";

import { ColorLabels } from "@/components/editor/utils/colors";
import { MIN_DESKTOP_WIDTH } from "@/utils/constants";

export const BlockBackgroundColorWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors[ColorLabels.BACKGROUND]};
`;

export const BlockPaddingWrapper = styled.div`
  padding: ${rem(80)} ${rem(24)};
`;

export const BlockMaxWidthWrapper = styled.div<{ maxWidth?: string }>`
  max-width: ${({ maxWidth }) => maxWidth || MIN_DESKTOP_WIDTH};
  margin: auto;
`;
